import {Component, Input, OnInit} from '@angular/core';
import {ContactModel, EContactFieldType, EContactType} from '../../../../@models';
import {NbToastrService} from '@nebular/theme';

@Component({
  selector: 'ngx-form-list-contact-entry-preview',
  templateUrl: './form-list-contact-entry-preview.component.html',
  styleUrls: ['./form-list-contact-entry-preview.component.scss'],
})
export class FormListContactEntryPreviewComponent implements OnInit {
  @Input() value: ContactModel;
  @Input() popup: boolean = false;

  public fieldTypes = EContactFieldType;

  constructor() { }

  ngOnInit() {
  }

}
